
const initials = (value: string) => {
  if (value) {
    // Prep initials
    let initials = value.replace(/\./g, '').toLowerCase()

    // Make array of initials, 'Th' is counted as one initial
    let arrValue = initials.match(/(th|[a-z])/g)

    if (arrValue != null) {
      // Max 4 initials
      if (arrValue.length > 4) {
        arrValue = arrValue.slice(0, 4)
      }

      // Make initials uppercase, in case of "Th" only the first char
      // Place dots between the initials
      return arrValue.map(char => char.substring(0, 1).toUpperCase() + char.substring(1)).join('.') + '.'
    }

    return value
  }
}

export default initials



// WEBPACK FOOTER //
// ./src/filters/initials.js